import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ellipsify from 'utils/ellipsify';
import {
  ToolTipTvSeriesStyled,
  StyledImage,
  LeftPart,
  StyledTvText,
  TextTvWrap,
  TitleTextWrap,
  StyledText,
} from './styles/ToolTipTvSeriesStyled';

class ToolTipTvSeries extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const initEllipsify = setInterval(() => {
      if (this.titleRef) {
        ellipsify(this.titleRef);
        clearInterval(initEllipsify);
      }
    }, 150);
  }

  assignTitleRef = (ref) => {
    this.titleRef = ref;
  };

  render() {
    const { image, typeTvSeries, title, open } = this.props;
    return (
      <ToolTipTvSeriesStyled open={open}>
        {image && (
          <LeftPart>
            <StyledImage src={image} alt="" />
          </LeftPart>
        )}
        <LeftPart>
          <TextTvWrap>
            <StyledTvText color="gray_smokegray" size="xxs">
              {typeTvSeries}
            </StyledTvText>
          </TextTvWrap>
          {title && (
            <TitleTextWrap>
              <StyledText getRef={this.assignTitleRef} color="white" size="xxs">
                {title}
              </StyledText>
            </TitleTextWrap>
          )}
        </LeftPart>
      </ToolTipTvSeriesStyled>
    );
  }
}

ToolTipTvSeries.propTypes = {
  image: PropTypes.string,
  typeTvSeries: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};

ToolTipTvSeries.defaultProps = {
  image: null,
};

export default ToolTipTvSeries;
